import { useState, useEffect } from 'react';
import API, { fmt } from '@/lib/api';
import { Trash } from '@phosphor-icons/react';

export default function BtwPage() {
  const [btw, setBtw] = useState([]);
  const [q, setQ] = useState('');

  const load = () => API.get('/btw').then(r => setBtw(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm('BTW registratie verwijderen?')) return;
    await API.delete(`/btw/${id}`);
    load();
  };

  const filtered = btw.filter(b => !q || b.plaat.toLowerCase().includes(q.toLowerCase()) || b.merk.toLowerCase().includes(q.toLowerCase()) || b.klant.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="btw-page">
      <div className="flex items-center justify-between mb-6">
        <h1 className="page-heading mb-0">BTW Voertuigenregister</h1>
      </div>

      <div className="mb-4">
        <input className="field-input" style={{ maxWidth: 250 }} placeholder="Zoeken..." value={q} onChange={e => setQ(e.target.value)} data-testid="btw-search" />
      </div>

      <div className="section-card">
        <div className="section-body">
          <table className="data-table">
            <thead><tr><th>Nummer</th><th>Nummerplaat</th><th>VIN</th><th>Merk/Model</th><th>Jaar</th><th>Klant</th><th>Status</th><th className="right">Prijs</th><th></th></tr></thead>
            <tbody>
              {filtered.map(b => (
                <tr key={b.id}>
                  <td className="mono"><span className="doc-nr">{b.id}</span></td>
                  <td className="mono font-bold">{b.plaat}</td>
                  <td className="mono text-xs">{b.vin}</td>
                  <td>{b.merk} {b.model}</td>
                  <td>{b.jaar}</td>
                  <td>{b.klant}</td>
                  <td><span className={`badge ${b.status === 'nieuw' ? 'badge-green' : 'badge-blue'}`}>{b.status}</span></td>
                  <td className="right font-medium">{fmt(b.prijs)}</td>
                  <td><button className="btn btn-danger btn-sm" onClick={() => del(b.id)} data-testid={`del-btw-${b.id}`}><Trash size={14} /></button></td>
                </tr>
              ))}
              {filtered.length === 0 && <tr><td colSpan="9" className="text-center text-gray-400 py-8">Geen voertuigen</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
